module.exports = __webpack_public_path__ + "static/media/envios.5bd8e8bf.png";